import React from "react";
// Material
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePickerProps,
} from "@material-ui/pickers";
// Libs
import DateFnsUtils from "@date-io/date-fns";
import defaultLocale from "date-fns/locale/pt-BR";
import { IEnumerable } from "../../core/models/ModelHelpers";
import uuidv4 from "../../helpers/uuid";
import {
  DATEPICKER_MAX_DATE_MESSAGE,
  DATEPICKER_MIN_DATE_MESSAGE,
} from "../../core/constants/datePickerConstants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& div": {
        "fontSize": 13,

        "& div": {
          "& button": {
            padding: 12,
          },
        },
      },

      "& .MuiInput-underline:after": {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      },

      "& .MuiOutlinedInput-input": {
        padding: theme.spacing(1.5, 0, 1.5, 2),
      },

      "& .MuiOutlinedInput-adornedEnd": {
        background: theme.palette.common.white,
        paddingRight: 0,
      },

      "& .MuiFormHelperText-root.Mui-error": {
        maxWidth: "15rem",
      },
    },

    error: {
      "& div": {
        "fontSize": 13,
        "background": theme.palette.common.white,

        "& div": {
          "& button": {
            padding: "12px",
          },
        },
      },

      "& label": {
        color: theme.palette.error.main,
      },

      "& .MuiInput-underline:after": {
        borderBottom: `2px solid ${theme.palette.error.main}`,
      },

      "& .MuiInput-underline.Mui-error:after": {
        borderBottom: `2px solid ${theme.palette.error.main}`,
      },
    },
  })
);

type MaterialDatePickerComponentProps = {
  clearable?: boolean;
  initialDate?: Date;
  id?: IEnumerable;
  error?: boolean;
} & KeyboardDatePickerProps;

function MaterialDatePickerComponent(props: MaterialDatePickerComponentProps) {
  const classes = useStyles();
  const { value, clearable, id, error, ...others } = props;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const useId = React.useMemo(() => id || uuidv4(), []);

  return (
    <MuiPickersUtilsProvider key={useId} utils={DateFnsUtils} locale={defaultLocale}>
      <KeyboardDatePicker
        className={error ? classes.error : classes.root}
        id={useId}
        emptyLabel={"Selecione uma data"}
        format="dd/MM/yyyy"
        inputVariant={"outlined"}
        invalidDateMessage="Data inválida"
        maxDateMessage={others.maxDateMessage || DATEPICKER_MAX_DATE_MESSAGE}
        minDateMessage={others.minDateMessage || DATEPICKER_MIN_DATE_MESSAGE}
        cancelLabel="Cancelar"
        clearLabel="Limpar"
        todayLabel="Hoje"
        strictCompareDates
        {...others}
        value={clearable && value === null ? null : value}
        onChange={others.onChange}
      />
    </MuiPickersUtilsProvider>
  );
}

export default MaterialDatePickerComponent;
